import React from "react"
import clsx from "clsx"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"

interface Props {
     isExtracting: boolean
     isDragging: boolean
     setIsDragging: (val: boolean) => void
     onDrop: (files: FileList | null) => void
     fileInputRef: React.RefObject<HTMLInputElement>
}

const Step1Dropzone = ({ isExtracting, isDragging, setIsDragging, onDrop, fileInputRef }: Props) => {
     if (isExtracting) {
          return (
               <div className="py-15 text-center bg-light-primary border border-primary border-dashed rounded shadow-sm">
                    <div className="mb-5">
                         <MySimpleSpinner size="xl" />
                    </div>
                    <h4 className="fw-bolder text-primary mb-2 fs-3">Analyse en cours...</h4>
                    <p className="text-gray-600 fw-semibold fs-6 mb-0 px-10">Extraction automatique des coordonnées et informations de profil.</p>
               </div>
          )
     }

     return (
          <div
               className={clsx(
                    "rounded border-2 border-dashed p-10 text-center transition-all bg-body",
                    isDragging ? "border-primary bg-light-primary scale-102" : "border-gray-400"
               )}
               onDragOver={e => {
                    e.preventDefault()
                    setIsDragging(true)
               }}
               onDragLeave={() => setIsDragging(false)}
               onDrop={e => {
                    e.preventDefault()
                    setIsDragging(false)
                    onDrop(e.dataTransfer.files)
               }}
               onClick={() => fileInputRef.current?.click()}
               style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
               <i className="fas fa-cloud-upload-alt fs-3x text-primary mb-5"></i>
               <h3 className="fw-boldest fs-2 mb-3">Glissez les CV</h3>
               <p className="text-gray-600 fs-6 mb-0 px-20">
                    Glissez vos fichiers PDF ici ou cliquez pour parcourir. Talent va
                    <strong> extraire automatiquement</strong> les données pour vous. <br />
                    Limité à <b>**5 Mo et 5 pages**</b> par CV
               </p>
               <div className="mt-4 py-2 px-4 bg-light-info rounded-2 d-inline-block border border-info border-dashed">
                    <span className="fs-7 text-info fw-bold">Analyse Intelligente : Civilité, Nom, Prénom, Tél et Email.</span>
               </div>
          </div>
     )
}

export default Step1Dropzone
